const categoryPairs = [
    ['Antiques', 'Antique'],
    ['Doors', 'Exterior'],
    ['Doors', 'Interior'],
    ['Doors', 'Screen and Storm'],
    ['Doors', 'Other'],
    ['Windows', 'Stained and Leaded'],
    ['Windows', 'Other'],
    ['Plumbing', 'Bathtubs'],
    ['Plumbing', 'Sinks'],
    ['Plumbing', 'Fixtures'],
    ['Plumbing', 'Accessories'],
    ['Hardware', 'Doorknobs & Locksets'],
    ['Hardware', 'Doorbells & Knockers'],
    ['Hardware', 'Escutcheons'],
    ['Hardware', 'Door Pulls & Handles'],
    ['Hardware', 'Furniture Pulls & Handles'],
    ['Hardware', 'Other'],
    ['Lighting', 'Sconces'],
    ['Lighting', 'Shades and Globes'],
    ['Lighting', 'Flush and Semi-Flush'],
    ['Lighting', 'Hanging'],
    ['Lighting', 'Other'],
    ['Fireplace', 'Mantels'],
    ['Fireplace', 'Tools & Accessories'],
    ['Other', 'Architectural Elements'],
    ['Other', 'Heat and Ventilation'],
    ['Other', 'Stone, Garden, and Masonry'],
    ['Other', 'Newel Posts and Stair Parts'],
    ['Other', 'Salvaged Wood and Other Millwork'],
];

export const slugify = (value = '') => value
    .toString()
    .trim()
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const getCategoryPath = (category, subCategory) => (
    `/shop/${slugify(category)}/${slugify(subCategory)}`
);

export const getInventoryItemPath = (item) => (
    `${getCategoryPath(item.category, item.sub_category)}/${slugify(item.name)}-${item.id}`
);

export const getCategoryFromSlugs = (categorySlug, subCategorySlug) => {
    const match = categoryPairs.find(([category, subCategory]) => (
        slugify(category) === categorySlug && slugify(subCategory) === subCategorySlug
    ));

    if (!match) {
        return { category: '', subCategory: '' };
    }

    return { category: match[0], subCategory: match[1] };
};
